import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

export default function CarrierTeamMembersTabPanel({ vm }) {
  const {
    handleOpenDialog,
    handleDeleteMember,
    handleEditClick,
    rowsPerPageTeam,
    handleChangePageTeam,
    handleChangeRowsPerPageTeam,
    paginationSx,
    teamMembers,
    headerRowSx,
    pageTeam,
    tableCardSx,
    loading,
  } = vm;

  const renderBody = () => {
    if (loading) {
      return <CarrierTabLoadingRow colSpan={6} />;
    }
    if (teamMembers.length === 0) {
      return <CarrierTabEmptyRow colSpan={6} message="No team members found." />;
    }
    const slice = teamMembers.slice(
      pageTeam * rowsPerPageTeam,
      pageTeam * rowsPerPageTeam + rowsPerPageTeam,
    );
    return slice.map((member) => (
      <TableRow key={member.team_member_id ?? member.team_member_email}>
        <TableCell>{member.team_member_name}</TableCell>
        <TableCell align="right">{member.team_member_email}</TableCell>
        <TableCell align="right">{member.team_member_position}</TableCell>
        <TableCell align="right">{member.team_member_phonenumber}</TableCell>
        <TableCell align="right">{member.team_member_status ? "Available" : "Unavailable"}</TableCell>
        <TableCell align="right">{member.team_member_priority}</TableCell>
        <TableCell align="right">
          <IconButton color="primary" onClick={() => handleEditClick(member)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteMember(member.team_member_id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenDialog}>
          Add Team Member
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Team Member Name</TableCell>
              <TableCell align="right">Email</TableCell>
              <TableCell align="right">Position</TableCell>
              <TableCell align="right">Phone Number</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Priority</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={teamMembers.length}
        page={pageTeam}
        onPageChange={handleChangePageTeam}
        rowsPerPage={rowsPerPageTeam}
        onRowsPerPageChange={handleChangeRowsPerPageTeam}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierTeamMembersTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
